import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FloatLabel } from 'primeng/floatlabel';
import { MyMonitoringService } from '../../../services/logging.service';
import { ControlValueAccessor } from '@angular/forms';
import { SELECT_VALUE_ACCESSOR, SelectChangeEvent, SelectModule } from 'primeng/select';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [SelectModule, FormsModule, FloatLabel],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']

})

export class DropdownComponent implements ControlValueAccessor {
  @Input() options: any[] = [];
  @Input() selectedValue: any;
  @Input() placeholder: string = 'Select';
  @Input() label: string = '';
  @Input() customClass: string = '';
  @Input() showLabel: boolean = false;
  @Input() inputlabel: string = '';
  @Input() required: boolean = false;
  @Input() showFloatingLabel: boolean = false;
  @Input() validationName: string = '';
  @Input() isFormSubmitted: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Output() selectedValueChange = new EventEmitter<any>();
  touched: boolean = false;
  @Input() customWidth: string = '';

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onValueChange(event: any) {
    this.selectedValueChange.emit(this.selectedValue);
    this.touched = true;
    this.isFormSubmitted = true;
    this.selectedValue = event.value;
    this.onChange(this.selectedValue);
    this.onTouched();
  }

  get isInvalid() {
    return this.required && !this.selectedValue && (this.touched || this.isFormSubmitted);
  }

  get isDisabledState(): boolean {
    return this.disabled || this.readonly;
  }
  private onChange: any = () => { };
  private onTouched: any = () => { };
}
